import { TranslationKey } from "../i18n/i18n";

const REQUEST_ERROR_TRANSLATION_KEYS: Record<string, TranslationKey> = {
  ACCESS_DENIED: "request.error.accessDenied",
  ACTIVE_SUBSCRIPTION_NOT_FOUND: "request.error.activeSubscriptionNotFound",
  AUTHENTICATION_REQUIRED: "request.error.authenticationRequired",
  CONNECTED_DOMAIN_APEX_NOT_ALLOWED: "request.error.connectedDomainApexNotAllowed",
  CONNECTED_DOMAIN_ARCHIVED: "request.error.connectedDomainArchived",
  CONNECTED_DOMAIN_CNAME_NOT_FOUND: "request.error.connectedDomainCnameNotFound",
  CONNECTED_DOMAIN_HOSTNAME_INVALID: "request.error.connectedDomainHostnameInvalid",
  CONNECTED_DOMAIN_HOSTNAME_UNAVAILABLE: "request.error.connectedDomainHostnameUnavailable",
  CONNECTED_DOMAIN_NOT_FOUND: "request.error.connectedDomainNotFound",
  CONNECTED_DOMAIN_TARGET_MISMATCH: "request.error.connectedDomainTargetMismatch",
  DNS_CONFIGURATION_INVALID: "request.error.dnsConfigurationInvalid",
  DNS_OPERATION_FAILED: "request.error.dnsOperationFailed",
  EMAIL_VERIFICATION_REQUIRED: "request.error.emailVerificationRequired",
  INVALID_CREDENTIALS: "request.error.invalidCredentials",
  INVITATION_INVALID: "request.error.invitationInvalid",
  INVITATION_NOT_FOUND: "request.error.invitationNotFound",
  MANAGED_DOMAIN_ARCHIVED: "request.error.managedDomainArchived",
  MANAGED_DOMAIN_HOSTNAME_UNAVAILABLE: "request.error.managedDomainHostnameUnavailable",
  MANAGED_DOMAIN_IN_USE_BY_CONNECTED_DOMAIN: "request.error.managedDomainInUse",
  MANAGED_DOMAIN_LABEL_INVALID: "request.error.managedDomainLabelInvalid",
  MANAGED_DOMAIN_LABEL_RESERVED: "request.error.managedDomainLabelReserved",
  MANAGED_DOMAIN_LABEL_UNAVAILABLE: "request.error.managedDomainLabelUnavailable",
  MANAGED_DOMAIN_NOT_FOUND: "request.error.managedDomainNotFound",
  NOT_FOUND: "request.error.notFound",
  ORGANIZATION_DISABLED: "request.error.organizationDisabled",
  ORGANIZATION_DOMAIN_SETTINGS_NOT_FOUND: "request.error.organizationDomainSettingsNotFound",
  ORGANIZATION_NOT_FOUND: "request.error.organizationNotFound",
  ORGANIZATION_USER_MEMBERSHIP_NOT_FOUND: "request.error.organizationUserMembershipNotFound",
  PASSWORD_RESET_INVALID: "request.error.passwordResetInvalid",
  PROFILE_NOT_FOUND: "request.error.profileNotFound",
  SESSION_NOT_FOUND: "request.error.sessionNotFound",
  SIGN_NOT_FOUND: "request.error.signNotFound",
  SITE_NOT_FOUND: "request.error.siteNotFound",
  TERMS_OF_USE_NOT_FOUND: "request.error.termsOfUseNotFound",
  TOTP_CODE_INVALID: "request.error.totpCodeInvalid",
  TOTP_SETUP_REQUIRED: "request.error.totpSetupRequired",
  TRANSLATION_MAX_LENGTH_EXCEEDED: "request.error.translationMaxLengthExceeded",
  TRANSLATION_NOT_FOUND: "request.error.translationNotFound",
  UNEXPECTED_ERROR: "request.error.unexpected",
  USER_ALREADY_EXISTS: "request.error.userAlreadyExists",
  USER_NOT_FOUND: "request.error.userNotFound",
  VALIDATION_ERROR: "request.error.validation",
  VERIFY_EMAIL_INVALID: "request.error.verifyEmailInvalid",
};

export const resolveRequestErrorMessage = (
  errorCode: null | string | undefined,
  t: (key: TranslationKey) => string,
  fallbackKey: TranslationKey = "request.error.generic",
) => {
  if (!errorCode) {
    return t(fallbackKey);
  }
  const translationKey = REQUEST_ERROR_TRANSLATION_KEYS[errorCode];
  return translationKey ? t(translationKey) : t(fallbackKey);
};
